import React, { useEffect, useState } from "react";
import ProjectCard from "../components/ProjectCard";
import { getProjects } from "../api";

const CATEGORIES = ["All", "Mobile App", "Web App", "IoT", "Other"];

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("All");
  const [search, setSearch] = useState("");

  useEffect(() => {
    getProjects()
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        setProjects(data);
        setFiltered(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = projects;
    if (activeCategory !== "All") {
      result = result.filter((p) => p.category === activeCategory);
    }
    if (search.trim()) {
      const q = search.toLowerCase();
      result = result.filter(
        (p) =>
          p.title.toLowerCase().includes(q) ||
          p.description.toLowerCase().includes(q) ||
          p.techStack?.some((t) => t.toLowerCase().includes(q))
      );
    }
    setFiltered(result);
  }, [activeCategory, search, projects]);

  return (
    <div style={{ paddingTop: 100 }}>
      <div className="container" style={{ paddingBottom: 80 }}>
        <p style={{ color: "var(--accent)", fontWeight: 600, fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 8 }}>
          Portfolio
        </p>
        <h1 className="section-title">All Projects</h1>
        <p className="section-sub">Everything we have built.</p>
        <input
          type="text"
          placeholder="Search projects..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ maxWidth: 420, marginBottom: 24 }}
        />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 36 }}>
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              style={{
                padding: "7px 18px", borderRadius: 999, fontSize: 13, fontWeight: 500,
                background: activeCategory === cat ? "var(--accent)" : "var(--card)",
                color: activeCategory === cat ? "#000" : "var(--muted)",
                border: "1px solid",
                borderColor: activeCategory === cat ? "var(--accent)" : "var(--border)",
                transition: "all 0.2s",
              }}
            >
              {cat}
            </button>
          ))}
        </div>
        {loading ? (
          <div className="spinner" />
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "var(--muted)" }}>
            <p style={{ fontSize: 36, marginBottom: 12 }}>??</p>
            <p>No projects found.</p>
          </div>
        ) : (
          <>
            <p style={{ color: "var(--muted)", fontSize: 13, marginBottom: 20 }}>
              Showing {filtered.length} project{filtered.length !== 1 ? "s" : ""}
            </p>
            <div className="projects-grid">
              {filtered.map((p) => <ProjectCard key={p._id} project={p} />)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
